import Shiitake from 'shiitake';
import * as React from 'react';
import { PreziCardOuterDiv, PreziImage, PreziThumbnail, ReuseContainerStyles, ReuseIcon, TextTruncate, ThumbnailInfo } from '../../styles/PreziCard'
import LazyLoad from 'react-lazyload';

import { PreziData } from '../App';
import { WindowSizeBreakpoints, DesktopLazyLoadOffset, MobileLazyLoadOffset } from '../../components/Consts';

interface PreziCardProps {
    prezi: PreziData;
}

const ReuseContainer: React.SFC<{}> = () => {
    return (
        <ReuseContainerStyles>
            <ReuseIcon className="icon-reuse" />
        </ReuseContainerStyles>
    );
};

export const PreziCard: React.SFC<PreziCardProps> = (props: PreziCardProps) => {
    const urlWithClickTracking = `${props.prezi.landing_url}?click_source=logged_element&element_type=prezi_card&element_text=${ props.prezi.oid }`;
    const reuseContainer: React.ReactNode | null = props.prezi.can_reuse ? <ReuseContainer /> : null;
    const lazyLoadOffset: number = window.innerWidth > WindowSizeBreakpoints.SMALL ? DesktopLazyLoadOffset : MobileLazyLoadOffset;

    return (
        <div className={ 'col-xs-12 col-sm-4' }>
            <a className="no-underline" href={ urlWithClickTracking }>
                <PreziCardOuterDiv className="shadow-sm">
                    <PreziThumbnail>
                        { reuseContainer }
                        <LazyLoad height="200px" once={ true } offset={ lazyLoadOffset }>
                            <PreziImage className="img-responsive" src={ props.prezi.thumbnail_url } />
                        </LazyLoad>
                    </PreziThumbnail>
                    <ThumbnailInfo>
                        <Shiitake lines={ 1 } className="h4 btm-0" tagName="p">
                            { props.prezi.title }
                        </Shiitake>
                        <Shiitake lines={ 1 } className="small btm-6 text-gray-3 bold" tagName="p">
                            { props.prezi.owner_name }
                        </Shiitake>
                        <TextTruncate className="h4 btm-6">{ props.prezi.name }</TextTruncate>
                        <Shiitake lines={ 2 } className="small text-gray-3 semibold btm-0" tagName="p">
                            { props.prezi.description }
                        </Shiitake>
                    </ThumbnailInfo>
                </PreziCardOuterDiv>
            </a>
        </div>
    );
};



// WEBPACK FOOTER //
// ./assets/js/GalleryPage/PreziCard/PreziCard.tsx